import { render, staticRenderFns } from "./BrandInformationExtended.vue?vue&type=template&id=39bcdde2&"
import script from "./BrandInformationExtended.vue?vue&type=script&lang=js&"
export * from "./BrandInformationExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports